import styled from '@emotion/styled'

const InvisibleInput = styled.input(
  () => ({
    cursor: 'pointer',
    bottom: 0,
    height: '100%',
    left: 0,
    opacity: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    width: '100%',
    margin: 0,
  }),
  (props) =>
    !!props.disabled && {
      cursor: 'not-allowed',
    }
)

export default InvisibleInput
